// adding ignore list for now. need to take these components and pass the state from here (Home  and dept).

function ignoreList(componentName) {
    const listIgnore = ['header', 'footer'];
    return listIgnore.indexOf(componentName);
}

export default (oneComponent, index, cmCompleteComponentList) => {
    let mappedComponent = null;
    const { componentType } = oneComponent;
    /* istanbul ignore else */
    if (oneComponent.componentType && ignoreList(oneComponent.componentType) < 0) {
        const CustomComponent = cmCompleteComponentList[oneComponent.componentType?.toLowerCase()];
        mappedComponent = {
            componentType,
            component: CustomComponent,
            props: oneComponent,
            index,
        };
    }
    if (!mappedComponent) {
        console.warn('CM: component name missmatch, check CM Response');
    }
    return mappedComponent;
};
